'use client'
import '@dynamic-labs/sdk-api-core';
import '../../constants/values.js';
import '@dynamic-labs/utils';
import '../../../../../_virtual/_tslib.js';
import '@dynamic-labs/multi-wallet';
import '../../../shared/logger.js';
import '../../constants/colors.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../shared/consts/index.js';
import '../../../store/state/nonce/nonce.js';
import '../../../store/state/projectSettings/projectSettings.js';
import { requiresPasswordForEmbeddedWallet } from '../requiresPasswordForEmbeddedWallet/requiresPasswordForEmbeddedWallet.js';
import '../../../config/ApiEndpoint.js';
import '../../../store/state/user/user.js';
import '../../../locale/locale.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';

const requiresPasswordForEmbeddedWalletOnSignup = (projectSettings) => {
    const embeddedWalletsSettings = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets;
    if (!embeddedWalletsSettings) {
        return false;
    }
    return (requiresPasswordForEmbeddedWallet(projectSettings) &&
        Boolean(embeddedWalletsSettings.forceAuthenticatorAtSignup));
};

export { requiresPasswordForEmbeddedWalletOnSignup };
